import {IInstrument} from './IInstrument';
import {
    Container,
    InteractionEvent,
    LINE_CAP,
    LINE_JOIN,
    Matrix,
    Point,
    RenderTexture,
    Sprite,
    Texture
} from 'pixi.js';
import {DrawColor} from '../draw_menu/instument_top_block/color_picker/DrawColor';
import {StaticData} from '../../../data/StaticData';
import {PixiApplicationController} from '../../../controllers/PixiApplicationController';
import { SmoothGraphics } from '@pixi/graphics-smooth';
import {DrawHolderEvent} from '../draw_menu/events/DrawHolderEvent';

export class InstrumentBrush implements IInstrument
{
    private cursorGraphics: SmoothGraphics;
    private cursorSprite: Sprite;
    private _drawColor: DrawColor = DrawColor.BLACK;
    private _size: DrawColor = 0;
    private movePosition: Point = new Point();
    private onPointerIsDown: boolean = false;
    private cardRender: Sprite | undefined;

    constructor(private card: Sprite, private brushGraphics: SmoothGraphics, private brushGraphicsContainer: Container) {
        this.cursorSprite = new Sprite();
        this.cursorGraphics = new SmoothGraphics();

        this.cursorSprite.addChild(this.cursorGraphics);

        this.cursorSprite.interactive = this.cursorSprite.interactiveChildren = this.cursorSprite.buttonMode = false;
    }

    setRender(value: Sprite): void {
        this.cardRender = value;
    };

    setSize(value: number) {
        this._size = value;
        this.updateCursor();
    }

    setDrawColor(value: DrawColor) {
        this._drawColor = value;
        this.updateCursor();
    }

    start(): void {
        this.card.on('pointerover', this.onPointerOver, this);
        this.card.on('pointerout', this.onPointerOut, this);
        this.card.on('pointerdown', this.onPointerDown, this);
        this.card.on('pointermove', this.onDragMove, this);
        this.card.on('pointerup', this.onPointerUp, this);
        this.card.on('pointerupoutside', this.onPointerUp, this);

        this.card.interactive = true;
    };

    /**
     * Обработчик события pointerdown
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerDown(e: InteractionEvent): void {
        if (this.onPointerIsDown) {
            return;
        }
        this.brushGraphics.clear();
        this.movePosition = this.card.parent.toLocal(e.data.global, void 0);
        this.brushGraphics.lineStyle(0, 0);
        this.brushGraphics.beginFill(this._drawColor, 1, true);
        let x:number = this.movePosition.x;
        let y:number = this.movePosition.y;
        let radius:number = StaticData.drawCursorMinimalSize + (StaticData.drawCursorMaximalSize - StaticData.drawCursorMinimalSize) * this._size;
        this.brushGraphics.drawCircle(x, y, radius);
        this.brushGraphics.endFill();
        this.onPointerIsDown = true;
        this.brushGraphics.visible = true;
    }

    stop(): void {
        this.card.off('pointerover', this.onPointerOver, this);
        this.card.off('pointerout', this.onPointerOut, this);
        this.card.off('pointerdown', this.onPointerDown, this);
        this.card.off('pointermove', this.onDragMove, this);
        this.card.off('pointerup', this.onPointerUp, this);
        this.card.off('pointerupoutside', this.onPointerUp, this);

        this.card.interactive = false;
    };

    onPointerOver(e: InteractionEvent): void {
        this.cursorSprite.visible = true;
    }

    onPointerOut(e: InteractionEvent): void {
        this.cursorSprite.visible = false;
    }

    getCursor(): Sprite {
        return this.cursorSprite;
    }

    updateCursor(): void {
        this.cursorGraphics.clear();
        this.cursorGraphics.beginFill(this._drawColor, 1, true);
        this.cursorGraphics.drawCircle(0, 0, StaticData.drawCursorMinimalSize + (StaticData.drawCursorMaximalSize - StaticData.drawCursorMinimalSize) * this._size);
        this.cursorGraphics.endFill();
    }

    /**
     * Обработчик события pointerup
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerUp(e: InteractionEvent): void {
        this.onPointerIsDown = false;
        console.log("nb2");
        dispatchEvent(new MessageEvent(DrawHolderEvent.NEED_BACKUP));
        let transform: Matrix = new Matrix();
        transform.tx = Math.floor(this.card.width / 2);
        transform.ty = Math.floor(this.card.height / 2);
        PixiApplicationController.app.renderer.render(this.brushGraphicsContainer, {
            renderTexture: this.cardRender!.texture as RenderTexture,
            transform,
            clear: false
        });
        this.brushGraphics.visible = false;
    }

    /**
     * Обработчик события pointermove сцены
     * @param e Событие взаимодейтсвия пользователя
     */
    onDragMove(e: InteractionEvent): void {
        if (this.onPointerIsDown) {
            this.brushGraphics.moveTo(this.movePosition.x, this.movePosition.y);
        }
        this.movePosition = this.card.parent.toLocal(e.data.global, void 0);
        this.cursorSprite.x = this.movePosition.x;
        this.cursorSprite.y = this.movePosition.y;
        if (this.onPointerIsDown) {
            this.brushGraphics.lineStyle({
                width: (StaticData.drawCursorMinimalSize + (StaticData.drawCursorMaximalSize - StaticData.drawCursorMinimalSize) * this._size) * 2,
                //alignment: .5,
                //native: false,
                cap: LINE_CAP.ROUND,
                join: LINE_JOIN.ROUND,
                color: this._drawColor,
                miterLimit: 10
            });
            this.brushGraphics.lineTo(this.movePosition.x, this.movePosition.y);
        }
    }
}
